<app-page-hero-redesign
  [title]="'Platform'"
  [backgroundImage]="'assets/img/redesign/solutions/hero-page-bg.png'"
  [breadcrumbs]="[
    { label: 'Home', url: '/home-redesign' },
    { label: 'Platform' }
  ]">
</app-page-hero-redesign>
<app-about-intro-redesign
    [title]="'A Clinical AI Platform for Predictive Mental Healthcare'"
    [paragraphs]="[
        'Althea Soft is an enterprise AI-powered clinical platform designed to help healthcare institutions monitor patients in real time, detect early risk signals and coordinate multidisciplinary mental health care. ',

        'By giving authorised care teams access to real-time patient insights, Althea Soft helps hospitals, clinics and health systems move from fragmented and reactive care to a more predictive, connected and preventive model.'
    ]"
    [darkBackground]="false">
</app-about-intro-redesign>

<app-content-image-redesign
    [image]="'/assets/img/redesign/althea-care.png'"
    [imageAlt]="'AI Clinical Intelligence'"
    [title]="'AI Clinical Intelligence'"
    [paragraphs]="[
        'Althea Soft uses advanced AI models to analyse clinical data, biometric signals, behavioural patterns and patient history.',

        'The platform helps care teams identify early warning signs, detect relevant changes in patient status and generate predictive risk insights for conditions such as dementia, Alzheimer’s, schizophrenia, anxiety disorders and eating disorders.',

        'This intelligence supports clinicians with better context, helping them plan personalised interventions, monitor treatment evolution and make more informed decisions across the patient journey.'
        ]">
</app-content-image-redesign>
<app-platform-feature-redesign
    [title]="'Virtual Assistant & Voice Control'"
    [image]="'/assets/img/redesign/platform/voice-control.png'"
    [imageAlt]="'Virtual Assistant'"
    [paragraphs]="[
        'Althea Soft includes a voice-enabled AI assistant designed to help clinical teams interact with the platform more efficiently.',

        'Through natural language and hands-free voice queries, authorised professionals can access relevant patient information, review treatment history, check medication considerations, explore potential side effects and retrieve clinical recommendations or screening protocols. This allows doctors, psychologists, psychiatrists and care teams to obtain critical information faster during clinical workflows, consultations or multidisciplinary reviews.',

        'The assistant is designed to support clinical decision-making by reducing friction, improving access to patient context and helping teams act with greater speed and coordination.'
    ]">
</app-platform-feature-redesign>
<app-content-image-redesign
    [image]="'/assets/img/redesign/platform/monitoring.png'"
    [imageAlt]="'Real-Time Monitoring'"
    [title]="'Real-Time Monitoring'"
    [paragraphs]="[
        'Mental health risks often develop between appointments or outside the hospital environment.',
        
        'Althea Soft provides continuous monitoring of key patient indicators, including vitals, HRV trends, sleep patterns, symptoms, biomarker results and AI-generated insights.',

        'This real-time visibility helps clinical teams detect recurring issues earlier, respond to changes faster and improve care quality, patient follow-up and operational efficiency.'
    ]"
    
    [imageLeft]="false">
</app-content-image-redesign>
<app-platform-feature-redesign
    [title]="'Wearable Integration'"
    [image]="'/assets/img/redesign/platform/wearables.png'"
    [imageAlt]="'Wearable Integration'"
    [paragraphs]="[
        'Althea Soft integrates with wearable devices and connected health technologies to collect relevant patient signals continuously.',

        'The platform can support data from smartwatches, sensor patches, portable non-invasive brain monitoring devices and other digital health inputs, helping teams build a more complete picture of patient evolution.',

        'By connecting wearables with clinical intelligence, institutions can extend patient monitoring beyond the hospital while maintaining appropriate clinical oversight.'
    ]"
    [imageLeft]="true">
</app-platform-feature-redesign>
<app-platform-feature-redesign
    [title]="'Clinical Alerts'"
    [image]="'/assets/img/redesign/platform/alerts.png'"
    [imageAlt]="'Clinical Alerts'"
    [paragraphs]="[
        'The platform generates AI-powered alerts when relevant changes, anomalies or risk patterns are detected.',

        'These alerts help care teams prioritise patients, escalate cases when needed and act before a situation becomes critical.',
        
        'Automated alerts can support earlier intervention, reduce delays in communication and improve coordination across departments during high-risk situations.'
    ]"
    [imageLeft]="false">
</app-platform-feature-redesign>
<app-content-image-redesign
    [image]="'/assets/img/redesign/platform/coordination.png'"
    [imageAlt]="'Multidisciplinary Coordination'"
    [title]="'Multidisciplinary Coordination'"
    [paragraphs]="[
        'Althea Soft is designed to connect primary doctors, psychologists, psychiatrists, nurses and other authorised care professionals around shared patient information.',
        
        'Through a secure dashboard, teams can access real-time patient data, treatment history, biomarker trends, predictive risk scores, joint notes, secure messaging and video consultation tools.',

        'This helps reduce clinical silos, improve traceability and support coordinated decision-making across multidisciplinary teams.'
    ]">
</app-content-image-redesign>
<app-platform-feature-redesign
    [title]="'Data & Security'"
    [image]="'/assets/img/redesign/platform/data.png'"
    [imageAlt]="'Data & Security'"
    [paragraphs]="[
        'Althea Soft is built for regulated healthcare environments where privacy, security and compliance are essential.',
        
        'The platform supports secure data management, end-to-end encryption, controlled access, audit logs, compliance reporting and scalable infrastructure for institutional deployment.',

        'It is designed to help healthcare organisations store, manage and monitor sensitive patient data with confidence while supporting requirements such as GDPR, HIPAA and other applicable data protection frameworks.'
    ]"
    [imageLeft]="false">
</app-platform-feature-redesign>


<app-content-image-redesign
    [image]="'/assets/img/redesign/platform/aimodel.png'"
    [imageAlt]="'Real-Time Monitoring'"
    [title]="'Early Staging Prevention Models'"
    [paragraphs]="[
        'Memory and cognition — Alzheimer’s disease and other dementias, including markers of declining memory, function, and safety at home',
        'Thought and personality risk — schizophrenia-spectrum features and borderline-pattern instability',
        'Anxiety disorders — generalised anxiety, panic, and phobic presentations',
        'Mood disorders — major depression, bipolar disorder, and seasonal mood change',
        'Eating disorders — restrictive eating and binge–purge patterns',
    ]"
    
    [imageLeft]="false">
</app-content-image-redesign>


<app-platform-feature-redesign
    [title]="'Patented AI Models for the real world'"
    [image]="'/assets/img/redesign/platform/hud01.png'"
    [imageAlt]="'Patented AI Models'"
    [paragraphs]="[
        'The virtual encounter — mood, engagement, and distress as observed during a video visit',
        'Brain imaging review — change in brain volume and related atrophy markers from MRI or CT reports',
        'Brain-activity monitoring — wearable EEG as an adjunct signal in selected pathways',
        'Attention and neurodevelopment — ADHD and autism spectrum presentations',
        'Integrated clinical judgement support — combining history, body signals, behaviour, and monitoring into one narrative for the team'
    ]">
</app-platform-feature-redesign>

<app-cta-redesign
    [title]="'Designed for Clinical and Operational Impact'"
    [description]="[
        'Althea Soft translates complex patient data into actionable clinical intelligence',

        ' By combining AI, real-time monitoring, connected devices, automated alerts and multidisciplinary collaboration, the platform helps institutions anticipate risks, improve patient follow-up, reduce fragmented decision-making and optimise clinical resources.'
    ]"

></app-cta-redesign>